import { useQuery } from '@tanstack/react-query'

import { getItemById } from '@flecto/api/saas'
import { type ParameterID } from '@flecto/types'

type GetItemByIdProps = {
  item_id?: ParameterID
}

export function useQueryGetItemById({ item_id }: GetItemByIdProps) {
  return useQuery({
    queryKey: ['QueryGetItemById'],
    queryFn: async () => await getItemById(item_id ?? ''),
  })
}
